// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"349d9561","548":"b88c9080","613":"442aaacf","750":"ea6529ac","822":"60d69be6","826":"400ed05c"}[chunkId] + ".1793851335692.chunk.js";
};